import AssetsIssuanceAPI from "../../services/api/AssetsIssuance";
import { getPath } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";

function handleError(err) {
  console.log("error in driver Assets actions:", err);
}

export const setIssuingAssets = (payload) => {
  return {
    type: ActionTypes.ASSETS_ISSUANCE_SET_ISSUING_ASSETS,
    payload,
  };
};

export const resetIssuingAssets = (payload) => {
  return {
    type: ActionTypes.ASSETS_ISSUANCE_RESET_ISSUING_ASSETS,
    payload,
  };
};

export const setDriverDetails = (payload) => {
  return {
    type: ActionTypes.ASSETS_ISSUANCE_SET_DRIVER_DETAILS,
    payload,
  };
};

export const resetDriverDetails = (payload) => {
  return {
    type: ActionTypes.ASSETS_ISSUANCE_RESET_DRIVER_DETAILS,
    payload,
  };
};

export const setPartnerDetails = (payload) => {
  return {
    type: ActionTypes.ASSETS_ISSUANCE_SET_PARTNER_DETAILS,
    payload,
  };
};

export const resetPartnerDetails = (payload) => {
  return {
    type: ActionTypes.ASSETS_ISSUANCE_RESET_PARTNER_DETAILS,
    payload,
  };
};

export const verifyOtp = (payload) => async (dispatch) => {
  try {
    let response = await AssetsIssuanceAPI.verifyOtp(payload);
    if (response) {
      setStatus({
        type: "success",
        message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
      });
      return true;
    }
    return false;
  } catch (err) {
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
    return false;
  }
};

export const sendOtp = (payload) => async (dispatch) => {
  try {
    let response = await AssetsIssuanceAPI.sendOtp(payload);
    if (response) {
      setStatus({ type: "success", message: SuccessMessages.OTP_SEND_SUCCESS });
      return true;
    }
    return false;
  } catch (err) {
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
    return false;
  }
};

export const verifyIssuability = (payload) => async (dispatch) => {
  try {
    let response = await AssetsIssuanceAPI.verifyIssuability(payload);
    if (response) {
      if (Object.keys(getPath(response, "assets_data", {})).length === 0) {
        throw new Error("Some error in loading Assets :(");
      }
      dispatch(setDriverDetails(response));
      dispatch(setDriverDetails({ payload, response }));
      dispatch(setIssuingAssets(response));
      return true;
    }
    return false;
  } catch (err) {
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
    return false;
  }
};

export const getOnboardingCenter = (payload) => async (dispatch) => {
  try {
    let response = await AssetsIssuanceAPI.getOnboardingCenter(payload);
    if (response) {
      if (getPath(response, "onboarding_centers", []).length === 0) {
        throw new Error("User must have Onboaring center :(");
      }
      dispatch(
        setPartnerDetails(getPath(response, "onboarding_centers", [])[0])
      );
      return true;
    }
    return false;
  } catch (err) {
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const imageUpload = (payload) => async (dispatch) => {
  try {
    let response = await AssetsIssuanceAPI.imageUpload(payload);
    if (response) {
      return response;
    }
    return false;
  } catch (err) {
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
    return false;
  }
};
